var render = function render(){var _vm=this,_c=_vm._self._c;return _c('AutoCompleter',{ref:"completer",attrs:{"placeholder":_vm.placeholder,"results":_vm.results,"iid":_vm.iid},on:{"reload":_vm.reload,"selected":_vm.selectValue},scopedSlots:_vm._u([{key:"listitem",fn:function(data){return [_vm._v(" "+_vm._s(data.result.map_id)+" - "+_vm._s(data.result.customer.title)+" ")]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }